export default () => {
  require('fslightbox');
  const lightboxes = document.querySelectorAll('.js-lightbox');
  if(lightboxes) {
    const fsLightboxInstances = document.querySelectorAll('data-fslightbox');
    let breakpoint = window.matchMedia( '(min-width:1024px)' );
    breakpoint.addEventListener('change', initLightbox);
    initLightbox(breakpoint, fsLightboxInstances );
  }

  function initLightbox(breakpoint, fsLightboxInstances ) {
    if(fsLightboxInstances){
      fsLightboxInstances.forEach( lightbox => {
        if ( breakpoint.matches === true ) {
          lightbox.addEventListener('click', () => {
            lightbox['gallery'].props.onOpen
          });
        }
      });
    }
  }
}
